export const countryDropdown = {
  rexmonster: "1",
  monstergulf: "2",
  monsterhongkong: "3",
  monstersingapore: "4",
  monsterphilippines: "5",
  monsterthailand: "6",
  monstervietnam: "7",
  monsterindonesia: "8",
  monstermalaysia: "9",
};

const RECURITER_LOGIN_DATA = {
  rexmonster: "recruiter.foundit.in",
  monstergulf: "recruiter.founditgulf.com",
  monsterhongkong: "recruiter.foundit.hk",
  monstersingapore: "recruiter.foundit.sg",
  monsterphilippines: "recruiter.foundit.com.ph",
  monsterthailand: "recruiter.monster.co.th",
  monstervietnam: "recruiter.monster.com.vn",
  monsterindonesia: "recruiter.foundit.id",
  monstermalaysia: "recruiter.foundit.my",
};

export const getRecruiterLogin = (site_map: string) => {
  if (site_map in RECURITER_LOGIN_DATA) {
    const recruiterLogin =
      RECURITER_LOGIN_DATA[site_map as keyof typeof RECURITER_LOGIN_DATA] ||
      "recruiter.foundit.in";
    return recruiterLogin;
  }
  return "recruiter.foundit.in";
};
